module.exports = __webpack_public_path__ + "img/bg4.12b16384.png";